/**
 * Retrieve the language of the browser
 * @return The language of the browser or null if nothing is found
 */
export function getFirstBrowserLanguage(): string | null | undefined {
    const nav: any = window.navigator;
    const browserLanguagePropertyKeys = [
        'language', 'browserLanguage',
        'systemLanguage', 'userLanguage'
    ];

    // support for HTML 5.1 "navigator.languages"
    if (Array.isArray(nav.languages)) {
        return nav.languages.find((language: any) => language && language.length);
    }

    // support for other well known properties in browsers
    return browserLanguagePropertyKeys.find((val: string) => {
        const language = nav[val];
        return language && language.length;
    });
}

/**
 * Normalize the browser language to remove unnecessary content
 * fr-FR becomes FR
 * @param lang The browser language
 * @return The normlaized language
 */
export function normalizeBrowserLanguage(lang: string): string | null {
    if (lang == null || lang === '') {
        return null;
    }
    return lang.split('-')[0].toUpperCase();
}

/**
 * Return the default language for a user
 * @param languages List of supported languages
 * @return The default supported language
 */
export function getDefaultLanguage(languages: string[] = ['EN', 'FR']): string {
    const browserLanguage = getFirstBrowserLanguage();

    if (browserLanguage === null || browserLanguage === undefined) {
        return 'FR';
    }

    const locale: string = languages.find((l: string) => {
        return l.toLowerCase() === browserLanguage.toLowerCase();
    }) || 'FR';
    return locale.toUpperCase();
}

/**
 * Browser download
 * @param filename The filename
 * @param data The blob
 */
export function download(filename: string, data: Blob) {
    const element = document.createElement('a');
    element.href = window.URL.createObjectURL(data);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

/**
 * Get Url origin (http://test:500 or https://www.google.com)
 * @return The origin
 */
export function getUrlOrigin(): string {
    return window.location.origin;
}

/**
 * Get subdomain
 * @return The name of the subdomain
 */
export function getSubdomain(): string {
    // Not robust to co.uk, ....
    const parts = window.location.hostname.split('.');
    if (parts.length === 2) {
        return '';
    }

    return parts[0];
}

/**
 * Get Url host (test:500 or google.com)
 * @return The host
 */
export function getUrlHost(): string {
    return window.location.host;
}
